/**
 * 定制金 — Figma 图片资源映射
 */
import classicGold from '../classic-gold/images';

const floatBallMap = {
  amToEn: require('@/components/FloatBall/custom-gold/amToEn.png'),
  arToEn: require('@/components/FloatBall/custom-gold/arToEn.png'),
  arToFr: require('@/components/FloatBall/custom-gold/arToFr.png'),
  enToAm: require('@/components/FloatBall/custom-gold/enToAm.png'),
  enToAr: require('@/components/FloatBall/custom-gold/enToAr.png'),
  enToFr: require('@/components/FloatBall/custom-gold/enToFr.png'),
  enToPt: require('@/components/FloatBall/custom-gold/enToPt.png'),
  enToSw: require('@/components/FloatBall/custom-gold/enToSw.png'),
  enToTh: require('@/components/FloatBall/custom-gold/enToTh.png'),
  frToAr: require('@/components/FloatBall/custom-gold/frToAr.png'),
  frToEn: require('@/components/FloatBall/custom-gold/frToEn.png'),
  ptToEn: require('@/components/FloatBall/custom-gold/ptToEn.png'),
  swToEn: require('@/components/FloatBall/custom-gold/swToEn.png'),
  thToEn: require('@/components/FloatBall/custom-gold/thToEn.png'),
};

export default {
  ...classicGold,
  banner: require('@/assets/custom-gold/entry-hero.png'),
  header: require('@/assets/custom-gold/entry-hero.png'),
  headerMobile: require('@/assets/custom-gold/entry-hero.png'),
  bgi: require('@/assets/custom-gold/entry-hero.png'),
  bgiMobile: require('@/assets/custom-gold/entry-hero.png'),
  entryHero: require('@/assets/custom-gold/entry-hero.png'),
  paymentSelected: require('@/assets/custom-gold/payment-selected.png'),
  paymentUnselected: require('@/assets/custom-gold/payment-unselected.png'),
  warningIcon: require('@/assets/custom-gold/warning-icon.png'),
  copyPayHero: require('@/assets/custom-gold/copy-pay-hero.png'),
  copyPayCard: require('@/assets/custom-gold/copy-pay-card.png'),
  copyAmountIcon: require('@/assets/custom-gold/copy-amount-icon.png'),
  copyAccountIcon: require('@/assets/custom-gold/copy-account-icon.png'),
  copyNameIcon: require('@/assets/custom-gold/copy-name-icon.png'),
  copyWalletIcon: require('@/assets/custom-gold/copy-wallet-icon.png'),
  floatBallMap,
  entryPreview: require('@/assets/custom-gold/entry-preview.png'),
  copyPayPreview: require('@/assets/custom-gold/copy-pay-preview.png'),
};
